import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=132d105c&scoped=true"
import script from "./index3.vue?vue&type=script&lang=js"
export * from "./index3.vue?vue&type=script&lang=js"
import style0 from "./index3.vue?vue&type=style&index=0&id=132d105c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d105c",
  null
  
)

export default component.exports